module.exports = __webpack_public_path__ + "static/media/logo.67ecf314.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 240
// module chunks = 0